<a
  #cardLink
  tabindex="0"
  class="card card-type-{{ cardData?.type }}"
  [queryParams]="cardData?.params ? cardData.params : { auxclick: true }"
  [routerLink]="cardData?.url ? [cardData.url] : []"
  [target]="openNewTab ? '_blank' : '_self'"
  [rel]="openNewTab ? 'openoopener noreferrer' : null"
  [ngClass]="{
    'card--minimal': cardData?.cardStyle === 'minimal',
    'card--minimal-alt': cardData?.cardStyle === 'minimal-alt',
    'card--horizontal': cardData?.cardStyle === 'horizontal' || showCardBottom,
    'card--small': cardData?.size && cardData?.size === 'small',
    'card--halfnhalf': cardData?.cardStyle === 'halfnhalf',
    'card--halfnhalf-alt': cardData?.cardStyle === 'halfnhalf_alt',
    'card--article': cardData?.cardStyle === 'article',
    'card--dark': cardData?.darkTheme === true,
    'card--float': cardData?.cardStyle === 'float',
    'card--horizontal--minimal':
      cardData?.cardStyle === 'horizontal' && cardData?.darkTheme === false && cardData?.ribbon?.style !== 'arrow',
    'card--horizontal-alt': showCardBottom,
  }"
  (keyup.enter)="onCardClicked($event)"
  (keyup.space)="onCardClicked($event)"
  (auxclick)="onCardClicked($event)"
  (click)="onCardClicked($event)"
>
  <ng-container
    *ngIf="
      (badgesOnTop && cardData.type === 'dining-result') ||
        (!badgesOnTop && cardData.type === 'dining-result' && asyncPageLoad && !showCardBottom);
      else defaultRibbon
    "
  >
    <ng-container *ngFor="let tag of cardData.body.tags | slice: 0 : 3; let first = first; let last = last">
      <ten-card-ribbon
        class="ten-card-ribbon"
        [ngClass]="{
          'ten-card-ribbon--hide':
            cardData?.cardStyle !== 'halfnhalf' && cardData?.cardStyle !== 'halfnhalf_alt' && isShowMoreInfo,
          'ten-card-ribbon--first': cardData.body.tags.length > 1 && first,
          'ten-card-ribbon--last': cardData.body.tags.length > 1 && last,
        }"
        [ribbonData]="{ text: tag.text }"
      ></ten-card-ribbon>
    </ng-container>
  </ng-container>
  <ng-content select="[car]"> </ng-content>

  <ng-template #defaultRibbon>
    <ten-card-ribbon
      *ngIf="cardData?.ribbon && cardData?.ribbon.text"
      class="ten-card-ribbon"
      [ngClass]="{
        'ten-card-ribbon--hide':
          cardData?.cardStyle !== 'halfnhalf' && cardData?.cardStyle !== 'halfnhalf_alt' && isShowMoreInfo,
      }"
      [class.full-width]="cardData.ribbonFullWidth"
      [ribbonData]="cardData?.ribbon"
    ></ten-card-ribbon>
  </ng-template>

  <div
    #cardImage
    class="card__image"
    [ngClass]="{
      'card__image-ent-fallback': cardData?.type === 'entertainment' && !imageUrl,
      'card__image--halfnhalf': cardData?.cardStyle === 'halfnhalf',
      'card__image--halfnhalf-alt': cardData?.cardStyle === 'halfnhalf_alt',
      'card__image--horizontal-alt': showCardBottom,
    }"
  >
    <img
      class="card__image--real {{ cardData.imageClass }}"
      [ngClass]="{
        'card__image--real-show-info': isShowMoreInfo,
        'card__image--whole-picture': cardData?.cardStyle !== 'halfnhalf' && cardData?.cardStyle !== 'halfnhalf_alt',
        'card__image--object-fit-cover': isDefaultCarImage,
      }"
      *ngIf="imageUrl"
      [src]="imageUrl | imgResize: '523' : '500'"
      [alt]="cardData?.body?.heading"
      (error)="applyBackUpImage()"
    />
    <img
      *ngIf="!imageUrl && cardData.type === 'hotel'"
      class="card__image--real {{ cardData.imageClass }}"
      [src]="'/assets/images/hotel/default-image.webp' | imgResize: '523' : '500'"
      alt="default-hotel-image"
    />

    <ten-esg
      [cardStyle]="cardData?.cardStyle"
      [ngClass]="{
        'esg-horizontal': (cardData?.cardStyle === 'horizontal' && cardData.type === 'dining-result') || showCardBottom,
      }"
      [showIcon]="true"
      *ngIf="cardData?.isESG"
    ></ten-esg>
  </div>

  <div
    *ngIf="cardData?.instalmentPaymentsAvailable && cardData?.instalmentBannerText"
    class="instalments-banner"
    [class.instalments-banner--hide]="
      cardData?.cardStyle !== 'halfnhalf' && cardData?.cardStyle !== 'halfnhalf_alt' && isShowMoreInfo
    "
    [class.instalments-banner__car-hire]="cardData?.type === 'car'"
  >
    <mat-icon class="instalments-banner__icon" [class.instalments-banner__icon-car-hire]="cardData?.type === 'car'">
      payment
    </mat-icon>
    <span>{{ cardData.instalmentBannerText }}</span>
  </div>

  <ten-card-like
    *ngIf="cardData?.likeable && (cardData?.cardStyle === 'float' || cardData?.cardStyle === 'article')"
    [svgHtml]="likeSvg"
    [liked]="cardData.liked ? cardData.liked : false"
    (cardLiked)="onCardLiked($event)"
  >
  </ten-card-like>

  <div
    #cardBody
    class="card__body-wrapper"
    [ngClass]="{
      'card__body-wrapper--expanded': isShowMoreInfo,
      'card__body-horizontal': cardData?.cardStyle === 'horizontal' || showCardBottom,
      'card__body-horizontal-alt': showCardBottom,
    }"
  >
    <ten-follow-button
      [ngClass]="{ 'follow-button--horizontal': cardData?.cardStyle === 'horizontal' }"
      tabindex="0"
      (accessibleClick)="$event.stopPropagation()"
      *ngIf="(isFollowButtonEnabled$ | async) && cardData?.followButton"
      [followButtonData]="followButtonData"
      [id]="cardData?.tourAnchorId ? cardData?.tourAnchorId : ''"
      [tourAnchor]="cardData?.tourAnchorId ? cardData?.tourAnchorId : ''"
      (preferenceChange)="preferenceChange.emit($event)"
    ></ten-follow-button>

    <ten-card-body
      *ngIf="cardData?.body"
      class="card__body"
      [cardData]="cardData"
      [currency]="currency"
      [starSvgHtml]="starSvg"
      [badgesOnTop]="badgesOnTop"
      [asyncPageLoad]="asyncPageLoad"
      [showCardBottom]="showCardBottom"
      (isShowMoreInfo)="setIsShowMoreInfo($event)"
      (openModalParent)="openModal()"
      (cardClickedParent)="onCardClicked($event)"
    >
      <ng-content select="ten-card-value-proposition" ngProjectAs="ten-card-value-proposition"></ng-content>
      <ng-content select="[carBody]" ngProjectAs="carBody"></ng-content>
    </ten-card-body>
  </div>

  <div #cardBottom *ngIf="showCardBottom" class="card__bottom-wrapper">
    <ten-card-bottom [cardData]="cardData"></ten-card-bottom>
  </div>
</a>
